class BlogFilter extends HTMLElement {
  constructor() {
    super();

    const filter = document.querySelector("select");
    if (filter) {
      filter.addEventListener("change", function () {
        window.location.href = filter.value;
      });
    }
  }
}

customElements.define("blog-filter", BlogFilter);

class BlogFilterCheckboxes extends HTMLElement {
  constructor() {
    super();

    this.blogUrl = this.dataset.blogUrl;
    this.checkboxes = this.querySelectorAll(".blog-filter__input");
    this.allCheckbox = this.querySelector('[data-tag="all"]');
    this.articlesContainer = document.querySelector(".blog-articles");
    this.paginationContainer = document.querySelector(".pagination-wrapper");
    this.isLoading = false;

    this.checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", this.handleChange.bind(this));
    });
  }

  handleChange(event) {
    const checkbox = event.target;
    const tag = checkbox.dataset.tag;

    if (tag === "all") {
      if (checkbox.checked) {
        this.checkboxes.forEach((cb) => {
          if (cb.dataset.tag !== "all") {
            cb.checked = false;
          }
        });
        this.fetchArticles([]);
      }
      return;
    }

    if (this.allCheckbox) {
      this.allCheckbox.checked = false;
    }

    const selectedTags = [];
    this.checkboxes.forEach((cb) => {
      if (cb.checked && cb.dataset.tag !== "all") {
        selectedTags.push(cb.dataset.tag);
      }
    });

    if (selectedTags.length === 0) {
      if (this.allCheckbox) {
        this.allCheckbox.checked = true;
      }
      this.fetchArticles([]);
      return;
    }

    this.fetchArticles(selectedTags);
  }

  async fetchArticles(tags) {
    if (this.isLoading) return;
    this.isLoading = true;

    if (this.articlesContainer) {
      this.articlesContainer.classList.add("blog-articles--loading");
    }

    try {
      let combinedArticles = new Map();

      if (tags.length === 0) {
        // No tags selected - fetch all articles
        const response = await fetch(this.blogUrl);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const newArticles = doc.querySelector(".blog-articles");
        if (newArticles && this.articlesContainer) {
          this.articlesContainer.innerHTML = newArticles.innerHTML;
        }

        // Update pagination
        const newPagination = doc.querySelector(".pagination-wrapper");
        if (this.paginationContainer && newPagination) {
          this.paginationContainer.innerHTML = newPagination.innerHTML;
        } else if (this.paginationContainer) {
          this.paginationContainer.innerHTML = "";
        }

        window.history.pushState({}, "", this.blogUrl);
      } else {
        // Fetch articles for each tag and combine (OR logic)
        const fetchPromises = tags.map((tag) =>
          fetch(`${this.blogUrl}/tagged/${tag}`).then((res) => res.text())
        );

        const responses = await Promise.all(fetchPromises);
        const parser = new DOMParser();

        responses.forEach((html) => {
          const doc = parser.parseFromString(html, "text/html");
          const articles = doc.querySelectorAll(".blog-articles__article");

          articles.forEach((article) => {
            // Use article ID or URL as unique key to avoid duplicates
            const articleLink = article.querySelector("a");
            const articleKey = articleLink
              ? articleLink.getAttribute("href")
              : article.innerHTML;

            if (!combinedArticles.has(articleKey)) {
              combinedArticles.set(articleKey, article.outerHTML);
            }
          });
        });

        // Update articles container with combined results
        if (this.articlesContainer) {
          this.articlesContainer.innerHTML = Array.from(
            combinedArticles.values()
          ).join("");
        }

        // Hide pagination when using OR filter (mixed results)
        if (this.paginationContainer) {
          this.paginationContainer.innerHTML = "";
        }

        // Update URL
        const tagsPath = tags.join(",");
        window.history.pushState({}, "", `${this.blogUrl}?tags=${tagsPath}`);
      }
    } catch (error) {
      console.error("Error fetching articles:", error);
      window.location.href = this.blogUrl;
    } finally {
      this.isLoading = false;
      if (this.articlesContainer) {
        this.articlesContainer.classList.remove("blog-articles--loading");
      }
    }
  }
}

customElements.define("blog-filter-checkboxes", BlogFilterCheckboxes);
